document.addEventListener('DOMContentLoaded', function () {
  var app = document.getElementById('quiz-app');
  if (!app) return;

  var steps = Array.prototype.slice.call(app.querySelectorAll('.quiz-step'));
  var totalSteps = steps.length;
  var nextBtn = document.getElementById('quiz-next-btn');
  var currentStepLabel = document.getElementById('quiz-current-step');
  var currentStep = 1;

  function stepEl(stepNumber) {
    return steps[stepNumber - 1];
  }

  function optionRows(step) {
    return step.querySelectorAll('.option-row');
  }

  function isMultiSelect(step) {
    return step.getAttribute('data-select-mode') === 'multi';
  }

  function commitSelection(step) {
    var questionId = step.getAttribute('data-question-id');
    var hidden = document.getElementById(questionId + '-input');
    var selectedValues = [];

    optionRows(step).forEach(function (row) {
      if (row.classList.contains('selected')) {
        selectedValues.push(row.getAttribute('data-value'));
      }
    });

    var value = selectedValues.join(',');
    if (hidden) hidden.value = value;

    if (value) {
      localStorage.setItem(questionId, value);
    } else {
      localStorage.removeItem(questionId);
    }

    if (parseInt(step.getAttribute('data-step'), 10) === currentStep) {
      updateNextButtonState();
    }
  }

  function selectOption(step, optionEl) {
    var rows = optionRows(step);

    if (!isMultiSelect(step)) {
      rows.forEach(function (row) {
        row.classList.remove('selected');
        row.setAttribute('aria-selected', 'false');
      });
      optionEl.classList.add('selected');
      optionEl.setAttribute('aria-selected', 'true');
      commitSelection(step);
      return;
    }

    var isNone = optionEl.getAttribute('data-value') === 'none';

    if (isNone) {
      rows.forEach(function (row) {
        row.classList.remove('selected');
        row.setAttribute('aria-selected', 'false');
      });
      optionEl.classList.add('selected');
      optionEl.setAttribute('aria-selected', 'true');
    } else {
      rows.forEach(function (row) {
        if (row.getAttribute('data-value') === 'none') {
          row.classList.remove('selected');
          row.setAttribute('aria-selected', 'false');
        }
      });
      var nowSelected = !optionEl.classList.contains('selected');
      optionEl.classList.toggle('selected', nowSelected);
      optionEl.setAttribute('aria-selected', nowSelected ? 'true' : 'false');
    }

    commitSelection(step);
  }

  function restoreAnswer(step) {
    var questionId = step.getAttribute('data-question-id');
    var saved = localStorage.getItem(questionId);
    if (!saved) return;

    var hidden = document.getElementById(questionId + '-input');
    if (hidden) hidden.value = saved;

    var savedValues = saved.split(',');

    optionRows(step).forEach(function (row) {
      if (savedValues.indexOf(row.getAttribute('data-value')) !== -1) {
        row.classList.add('selected');
        row.setAttribute('aria-selected', 'true');
      }
    });
  }

  function initStep(step) {
    optionRows(step).forEach(function (row) {
      row.addEventListener('click', function () {
        selectOption(step, row);
      });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          row.click();
        }
      });
    });
  }

  function updateNextButtonState() {
    var step = stepEl(currentStep);
    var hasSelection = step.querySelector('.option-row.selected') !== null;
    nextBtn.disabled = !hasSelection;
  }

  function showStep(stepNumber) {
    steps.forEach(function (step) {
      step.setAttribute('hidden', '');
    });

    var current = stepEl(stepNumber);
    current.removeAttribute('hidden');

    if (currentStepLabel) currentStepLabel.textContent = stepNumber;

    nextBtn.querySelector('span').textContent =
      stepNumber === totalSteps ? 'See My Results' : 'Next Question';

    updateNextButtonState();

    current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function goNext() {
    if (currentStep === totalSteps) {
      submitQuiz();
      return;
    }
    currentStep++;
    showStep(currentStep);
  }

  function goBack(stepNumber) {
    currentStep = stepNumber;
    showStep(currentStep);
  }

  var categoryPoints = {
    // Q1 — What do you need socks for?
    "work-shifts":  { "compression": 3, "crew": 2 },
    "athletics":    { "athletic": 3, "compression": 1 },
    "travel":       { "compression": 3, "no-show": 1 },
    "recovery":     { "compression": 3, "crew": 1 },
    "everyday":     { "essentials": 3 },
    "curious":      { "essentials": 2 },

    // Q2 — How many hours a day are you on your feet?
    "under-4":  { "essentials": 1 },
    "4-to-8":   { "athletic": 1, "crew": 1 },
    "8-to-12":  { "compression": 2, "boot": 1 },
    "12-plus":  { "compression": 3, "boot": 2 },

    // Q3 — What are your feet telling you?
    "tired-achy":         { "compression": 2, "crew": 1 },
    "swelling":           { "compression": 3 },
    "blisters-hot-spots": { "no-show": 2 },
    "shins-calves":       { "crew": 2, "boot": 1 },
    "nothing-yet":        { "essentials": 2 },

    // Q4 — What's on your feet most days?
    "steel-toe-boots":   { "boot": 3, "mil-spec": 1 },
    "sneakers-trainers": { "athletic": 2, "crew": 1 },
    "cleats-turf":       { "athletic": 3, "ankle": 1 },
    "non-slips":         { "crew": 2, "compression": 1 },
    "dress-casual":      { "dress": 3 },

    // Q5 — If you're training or competing, what's your thing?
    "running":         { "no-show": 2, "ankle": 1, "athletic": 2 },
    "trail-running":   { "boot": 2, "athletic": 2 },
    "cycling":         { "crew": 2, "athletic": 2, "compression": 1 },
    "field-sports":    { "ankle": 2, "athletic": 2 },
    "soccer":          { "ankle": 2, "athletic": 2 },
    "tennis":          { "quarter": 2, "athletic": 2 },
    "golf":            { "crew": 2, "essentials": 1 },
    "hiking":          { "boot": 3 },
    "gym-training":    { "crew": 2, "athletic": 2 },
    "walking":         { "essentials": 2, "no-show": 1 },
    "injury-recovery": { "compression": 3 },
    "none":            {},

    // Q6 — Anything specific your feet need? (multi-select)
    "arch-support":       { "compression": 2, "athletic": 1 },
    "blister-protection": { "no-show": 2 },
    "extra-wide":         { "essentials": 2 },
    "seamless-toe":       { "essentials": 2 },
    "anti-odor":          { "athletic": 2, "essentials": 2 },

    // Q7 — What height do you like your socks?
    "no-show":       { "no-show": 3 },
    "ankle":         { "ankle": 3 },
    "quarter":       { "quarter": 3 },
    "crew":          { "crew": 3 },
    "boot":          { "boot": 3 },
    "no-preference": {},

    // Q8 — What matters most in a sock? (multi-select)
    "cushioning":       { "essentials": 2, "crew": 1 },
    "breathability":    { "no-show": 2, "essentials": 2 },
    "moisture-wicking": { "athletic": 2, "no-show": 1 },
    "durability":       { "boot": 2 },

    // Q9 — What kind of climate do you live in?
    "hot":  { "no-show": 2, "ankle": 2 },
    "mild": { "crew": 2 },
    "cold": { "boot": 3 },
    "all":  { "essentials": 2 }
  };

  function submitQuiz() {
    var scores = {};

    steps.forEach(function (step) {
      var questionId = step.getAttribute('data-question-id');
      var stored = localStorage.getItem(questionId);
      if (!stored) return;

      stored.split(',').forEach(function (value) {
        var pointMap = categoryPoints[value];
        if (!pointMap) return;
        Object.keys(pointMap).forEach(function (cat) {
          scores[cat] = (scores[cat] || 0) + pointMap[cat];
        });
      });
    });

    var topCategory = null;
    var maxScore = 0;
    Object.keys(scores).forEach(function (cat) {
      if (scores[cat] > maxScore) {
        topCategory = cat;
        maxScore = scores[cat];
      }
    });

    localStorage.setItem('topCategory', topCategory || 'essentials');

    window.location.href = '/pages/personalized-quiz-results?category=' + encodeURIComponent(topCategory || 'essentials');
  }

  steps.forEach(initStep);
  steps.forEach(restoreAnswer);

  app.querySelectorAll('[data-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      goBack(currentStep - 1);
    });
  });

  nextBtn.addEventListener('click', goNext);

  showStep(1);

  app.querySelectorAll('[data-quiz-carousel]').forEach(initQuizCarousel);
});

function initQuizCarousel(carousel) {
  var track = carousel.querySelector('[data-carousel-track]');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  if (slides.length < 2) return;

  var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
  var intervalMs = parseInt(carousel.getAttribute('data-autoplay-interval'), 10) || 4000;
  var index = 0;
  var timer;

  function goTo(newIndex) {
    index = (newIndex + slides.length) % slides.length;
    track.style.transform = 'translateX(-' + index * 100 + '%)';
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function stop() {
    if (timer) clearInterval(timer);
  }

  function start() {
    stop();
    timer = setInterval(function () {
      goTo(index + 1);
    }, intervalMs);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.getAttribute('data-index'), 10));
      start();
    });
  });

  goTo(0);
  start();
}
